import { EAnalyticMode } from '~/modules/analytics/types';
import { DEFAULT_ANALYTIC_MODE } from '../constants';
import { EReportParamKeys } from '../types';

export const getAnalyticModeFromSearchParams = (searchParams: URLSearchParams): EAnalyticMode => {
  const mode = searchParams.get(EReportParamKeys.MODE) as EAnalyticMode;

  if (Object.values(EAnalyticMode).includes(mode)) {
    return mode;
  }

  return DEFAULT_ANALYTIC_MODE;
};
